import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-devops',
  imports: [CommonModule, RouterLink],
  templateUrl: './devops.html',
  styleUrl: './devops.css'
})
export class Devops {
  services = [
    {
      title: 'CI/CD Pipeline Automation',
      description: 'Streamline development with automated build, test, and deployment pipelines for faster releases.',
      icon: 'cicd',
      link: '/devops/cicd',
      image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=400&h=300&fit=crop'
    },
    {
      title: 'Infrastructure as Code',
      description: 'Automate infrastructure provisioning and management with Terraform, CloudFormation, and Ansible.',
      icon: 'iac',
      link: '/devops/iac',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=300&fit=crop'
    },
    {
      title: 'Containerization & Orchestration',
      description: 'Deploy scalable applications with Docker, Kubernetes, and modern container orchestration.',
      icon: 'containers',
      link: '/devops/containers',
      image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?w=400&h=300&fit=crop'
    },
    {
      title: 'DevSecOps & Compliance',
      description: 'Integrate security into every phase with automated scanning, compliance checks, and vulnerability management.',
      icon: 'devsecops',
      link: '/devops/devsecops',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=300&fit=crop'
    },
    {
      title: 'Monitoring & Observability',
      description: 'Gain deep insights with comprehensive monitoring, logging, and alerting across your infrastructure.',
      icon: 'monitoring',
      link: '/devops/monitoring',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop'
    },
    {
      title: 'Cloud Cost Optimization (FinOps)',
      description: 'Reduce cloud spending by up to 60% through intelligent resource management and cost optimization.',
      icon: 'finops',
      link: '/devops/finops',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop'
    }
  ];

  caseStudies = [
    {
      client: 'FinanceFlow Inc',
      industry: 'Financial Services',
      challenge: 'Manual deployments caused frequent production incidents and delayed releases by weeks.',
      solution: 'Implemented end-to-end CI/CD pipelines with automated testing, security scanning, and zero-downtime deployments.',
      results: ['95% reduction in deployment time', '78% decrease in production incidents', '10x increase in deployment frequency'],
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop'
    },
    {
      client: 'HealthTech Solutions',
      industry: 'Healthcare Technology',
      challenge: 'Infrastructure provisioning took weeks and lacked consistency across environments.',
      solution: 'Migrated to Infrastructure as Code with Terraform, implementing automated environment creation and compliance controls.',
      results: ['90% faster environment provisioning', '100% infrastructure consistency', 'HIPAA compliance automated'],
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop'
    },
    {
      client: 'E-Commerce Global',
      industry: 'Retail',
      challenge: 'Cloud costs spiraling out of control with $500K monthly spend and poor resource utilization.',
      solution: 'Implemented comprehensive FinOps strategy with auto-scaling, rightsizing, and reserved instance optimization.',
      results: ['58% reduction in cloud costs', '$290K monthly savings', '85% improvement in resource efficiency'],
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop'
    }
  ];

  testimonials = [
    {
      quote: 'HoneyKode transformed our DevOps practices. What used to take weeks now happens in minutes. Our deployment frequency increased 10x while incidents dropped dramatically.',
      author: 'James Patterson',
      role: 'CTO',
      company: 'FinanceFlow Inc',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
    },
    {
      quote: 'Their Infrastructure as Code expertise saved us months of work. We now have consistent, compliant environments that spin up in minutes instead of weeks.',
      author: 'Dr. Sarah Williams',
      role: 'VP of Engineering',
      company: 'HealthTech Solutions',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
    },
    {
      quote: 'The FinOps optimization reduced our cloud bill by nearly 60% without impacting performance. The ROI was immediate and substantial.',
      author: 'Michael Chen',
      role: 'Director of Infrastructure',
      company: 'E-Commerce Global',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
    }
  ];

  stats = [
    { value: '1000+', label: 'Deployments Automated' },
    { value: '50M+', label: 'Resources Managed' },
    { value: '60%', label: 'Average Cost Savings' },
    { value: '99.99%', label: 'Uptime Achieved' }
  ];
}
